import React from 'react'
import { useDataProvider } from 'react-admin'

// Context to share VNC-enabled modality IDs across components
export const VncEnabledContext = React.createContext({ 
  vncEnabledIds: [], 
  fileTransferEnabledIds: [] 
})

export const VncEnabledProvider = ({ children }) => {
  const dataProvider = useDataProvider()
  const [vncEnabledIds, setVncEnabledIds] = React.useState([])
  const [fileTransferEnabledIds, setFileTransferEnabledIds] = React.useState([])

  React.useEffect(() => {
    const fetchVncConfigs = async () => {
      try {
        const { data } = await dataProvider.getList('vnc/configs', {
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'id', order: 'ASC' },
          filter: {}
        })
        
        console.log('[VNC] Fetched configs:', data)
        
        // Extract modality IDs that have VNC enabled
        const enabledIds = (data || [])
          .filter(config => config.enabled)
          .map(config => config.modalityId)
        setVncEnabledIds(enabledIds)
        console.log('[VNC] VNC enabled modality IDs:', enabledIds)
        
        // Extract modality IDs that have file transfer enabled
        const ftEnabledIds = (data || [])
          .filter(config => config.fileTransferEnabled)
          .map(config => config.modalityId)
        setFileTransferEnabledIds(ftEnabledIds)
        console.log('[VNC] File transfer enabled modality IDs:', ftEnabledIds)
      } catch (err) {
        console.error('Error fetching VNC configs:', err)
      }
    }
    fetchVncConfigs()
  }, [dataProvider])

  return (
    <VncEnabledContext.Provider value={{ vncEnabledIds, fileTransferEnabledIds }}>
      {children}
    </VncEnabledContext.Provider>
  )
}

